import img1 from "./Blog1 B.jpg";
import img2 from "./Blog2 B.jpg";
import img3 from "./Blog3 B.jpg";
import img4 from "./Blog4.jpg";
import img5 from "./Blog5.jpg";
// import img4 from "./Blog4 B.jpg"; // Assuming you'll add these images
// import img5 from "./Blog5 B.jpg";

import img11 from "./Blog1 A.jpg";
import img12 from "./Blog2 A.jpg";
import img13 from "./Blog3 A.jpg";
// import img14 from "./Blog4 A.jpg"; // Assuming you'll add these images
// import img15 from "./Blog5 A.jpg";

export const blogs = [
  {
    id: "trophy-launch",
    title: "A Trophy Worthy of Legends: UPPVL Unveils its Symbol of Glory",
    date: "July 3rd, 2025",
    image: img1,
    image2: img11,
    content: `
### A New Era Begins with a Symbol of Excellence

On July 3rd, 2025, the Uttar Pradesh Pro Volleyball League (UPPVL) proudly unveiled its official trophy in a grand event attended by dignitaries, franchise owners, and sports personalities. More than just a shining artifact, this trophy represents the strength, ambition, and unity of 75 districts coming together to rewrite volleyball history.

### The Design Story: Crafted with Purpose

Inspired by the indomitable spirit of warriors and the rich cultural roots of Uttar Pradesh, the UPPVL trophy is a blend of traditional motifs and modern aesthetics. The golden arcs represent the unstoppable energy of the spike, while the central orb symbolizes the heart of Uttar Pradesh beating through every match.

Crafted by a team of national-level artisans and sports designers, the trophy embodies three key values of the league: *Grit. Glory. Growth.*

### Voices Behind the Moment

"This trophy is not just for the team that lifts it, but for every child in UP who dreams of representing their district one day," said *Mr. Kulwant Baliyan*, Founder of UPPVL, during the launch ceremony.

"It's the beginning of something massive — a revolution for local athletes," added *Mr. Girish Chandra Yadav*, Minister of State for Sport and Youth Welfare.

### A Spark for the Journey Ahead

With the trophy now unveiled, every serve, block, and dive in the coming season takes on new meaning. The stakes are real. The fight has begun.

*The question now is: Who will be the first to etch their name into UPPVL history?*

#UPPVL2025 #TrophyOfChampions #UPKaMahaKumbh
    `,
  },
  {
    id: "player-auction",
    title: "The Bidding Battle Begins: Inside the UPPVL 2025 Player Auction",
    date: "July 3rd, 2025",
    image: img2,
    image2: img12,
    content: `
### History Was Made — Before the First Match Was Played

The court may be silent for now, but the echo of bidding paddles and team cheers still rings across the halls of the UPPVL 2025 Player Auction, held on *July 3rd, 2025, at *The Gaurs Sarovar Premiere, Gaur City, Noida.

*Eight franchises, over 400 athletes, one goal:* Build the most formidable squad for UPPVL's inaugural season. The bidding sessions were intense, emotional, and full of pride as young players from small towns earned their rightful place in the professional circuit.

### Auction Highlights: Drama, Strategy, and Surprises

- *Ayodhya Super Kings* secured national-level icon *Amit Gulia*, a massive boost to their campaign.  
- *Kashi Warriors* shocked everyone with a smart pick — a state-level libero known for his clutch saves.  
- *Muzaffarnagar Lions* played a long-term game, investing in young blood with two U-19 sensations.  
- *Noida Thunders* went big on experience, acquiring three former nationals with proven match IQ.

### Auction Format Recap

Each franchise had a fixed budget cap, with strategic bidding spread across categories:
- Icon Players  
- Setters & Liberos  
- Attackers & Blockers  
- Emerging Players  

Over four hours, we saw *150 players signed, with each franchise building a squad of **10–12 players*, including 2 reserve athletes.

### Behind the Scenes: What You Didn't See

Tension was palpable as coaches consulted analytics sheets, franchise owners made gut calls, and team tables celebrated every winning bid like a match point. The auction wasn't just about numbers — it was about a *vision and belief*.

"We didn't come here for names. We came here for chemistry," said *Mrs. Pratibha Mishra*, Franchise Owner of Ayodhya Super Kings.

### The War Rooms Have Spoken, Now the Warriors Step Onto the Court

With teams now locked and rosters ready, the countdown to the *UPPVL 2025 season opener* is officially underway. *Let the games begin.*

#UPPVLAuction #SquadGoals
    `,
  },
  {
    id: "nivia-partnership",
    title: "NIVIA x UPPVL: Powering the Game, One Spike at a Time",
    date: "July 3rd, 2025",
    image: img3,
    image2: img13,
    content: `
### When Performance Meets Purpose

When the Uttar Pradesh Pro Volleyball League (UPPVL) envisioned a league that would inspire and uplift regional volleyball talent, it needed a partner that shared the same values of quality, consistency, and passion for sport.

*Enter NIVIA Sports*, India's most trusted name in professional-grade sports gear.

### Why NIVIA?

🏐 Decades of expertise in volleyball gear manufacturing  
🏐 Official supplier for multiple national-level tournaments  
🏐 Endorsed by international athletes and coaches  
🏐 Made-in-India brand supporting homegrown talent  

The UPPVL matches will now feature the *NIVIA VICTOR PRO volleyball*, known for its grip, flight control, and pro-level consistency.

### What This Means for Players

From warm-up sessions to final match points, every UPPVL athlete will be powered by NIVIA's high-performance:

- Volleyballs designed for elite play  
- Knee and elbow guards tailored for impact resistance  
- Training gear including cones, bands, and fitness kits  
- Net systems and court essentials  

"We're not just providing gear. We're helping fulfill dreams, power rallies, and create champions."

### More Than Equipment — A Movement

This collaboration is about enabling thousands of players across Uttar Pradesh to get inspired, to train better, and to aspire for *national and international levels of glory*.

Whether it's a trial match or the UPPVL Finals, *NIVIA* will be the name behind every leap, dive, and smash.

#NIVIAXUPPVL #PoweredByNivia
    `,
  },
  {
    id: "fixture-release",
    title: "Fixture Drop! UPPVL Season 1 Is Officially Underway",
    date: "August 1st, 2025",
    image: img4,
    image2: img4,
    content: `
### There's something special about a fixture release.

It's not just dates on a calendar. It's destiny scheduled.

Every matchup locked in is a chapter waiting to be written, a rivalry waiting to erupt.

And with the UPPVL Season 1 fixture now live, the stage is set.

The countdown begins — not just to matches, but to moments that make history.

### 🏐 It All Begins With a Bang: Noida Thunders vs Lucknow Tigers

On 7th August, the lights go up in Greater Noida.

And who opens the league?

Two titans from the heart of Uttar Pradesh: Noida Thunders vs Lucknow Tigers.

Noida — known for its explosive energy and tech-city tempo.

Lucknow — steeped in legacy, grace, and quiet domination.

This isn't just a match.

It's power vs poise, grit vs guile — the perfect storm to kick off Season 1.

### Why This Match Matters

● It's a capital clash — both teams carrying pride, pressure, and promise.  
● It sets the tempo for the league — and the tone is war-ready.  
● With rising stars on both sides, it might just give us the first viral spike of the season.  

And let's be honest — whoever wins this?

They don't just get 2 points. They get a mental edge over the entire league.

### 🗓 From Here On, It's Nonstop Volleyball

The full fixture is now public. And it's a thing of beauty.

Ten packed league days, followed by knockouts where every serve could be someone's last.

So whether you're a hometown loyalist or a pure sport buff — now's the time to pick your team, mark your matchdays, and get loud.

Because UPPVL Season 1 is ready to unfold.

And it begins with one killer serve on August 7th.
    `
  },
  {
    id: "league-purpose",
    title: "More Than a League: UPPVL is a Dream in Motion",
    date: "August 3rd, 2025",
    image: img5,
    image2: img4,
    content: `
### Before the jerseys were stitched, before the teams were named, before the courts were prepped — there were just players.

Boys who played barefoot on dusty grounds.

Girls who jumped higher than anyone ever expected.

Athletes who practiced without nets, but never lacked fire.

UPPVL was built for them.

### 🏐 For Every Player Who Was Told "It's Just a Hobby"

In every corner of Uttar Pradesh, volleyball has quietly lived in the shadows — played with passion, but rarely with prospects. It was the game of school breaks, village melas, army grounds... never the spotlight.

Until now.

The Uttar Pradesh Pro Volleyball League (UPPVL) was created to change that.

To take volleyball out of the margins and place it where it belongs — in the heart of the arena, on a platform that celebrates not just talent, but the journey behind it.

### 💥 Because Every Spike Has a Story

Behind every player in UPPVL, there's a story worth telling.

● A libero who trained with bricks instead of weights.  
● A captain who borrowed shoes to make trials.  
● A village team that took one motorcycle, 5 players, and a dream to a district win.  

These aren't just athletes — they're symbols of resilience. And now, they're getting the chance to shine on a professional stage with fans, cameras, and purpose.

### 🌆 8 Cities, 1 Heartbeat

Each franchise — from Kashi to Gorakhpur, Noida to Moradabad — represents more than a city. It represents a community, a culture, a way of playing.

These teams aren't built in boardrooms.

They're built in backyards, school gyms, temple courtyards, and rain-soaked fields.

And now, they wear their colors with pride — for everyone who believed in them before the world did.

### 💫 UPPVL Is Not Just a League

It's a love letter to every unseen effort.

It's the answer to every "what if?" a young athlete has ever asked.

It's proof that volleyball in UP was never small — it just needed space to grow.

And now, with UPPVL Season 1, it finally has that space.

The dream is real. The players are ready. The moment is here.

And it belongs to them.
    `
  }
];